import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AdminWalletResponse } from "reduxStore/dataTypes";

interface AdminWalletState {
  adminWallet: AdminWalletResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: AdminWalletState = {
  adminWallet: null,
  loading: false,
  error: null,
};

const adminWalletSlice = createSlice({
  name: "adminWallet",
  initialState,
  reducers: {
    adminWalletRequest(state) {
      state.loading = true;
      state.error = null;
    },
    adminWalletSuccess(state, action: PayloadAction<AdminWalletResponse>) {
      state.loading = false;
      state.adminWallet = action.payload;
    },
    adminWalletFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { adminWalletRequest, adminWalletSuccess, adminWalletFailure } =
  adminWalletSlice.actions;
export default adminWalletSlice.reducer;
